import { Form } from '~/shared/api'

export default class AddExtraDataForm extends Form {
  constructor(public id: string, public field: string, public value: string) {
    super()
  }
}
